import type { RendererProps } from "../core/element-registry"
import { Skeleton } from "../components/ui/skeleton"
import { cn } from "../lib/utils"

export function SkeletonRenderer({ element }: RendererProps) {
  const sizeClasses: Record<string, string> = {
    sm: "h-5 w-32",
    md: "h-8 w-3/4",
    lg: "h-20 w-full",
    square: "aspect-square w-full rounded-xl",
    button: "h-10 w-40",
  }

  const classes = sizeClasses[element.variant ?? "md"] ?? sizeClasses.md

  return <Skeleton className={cn(classes, element.className)} data-testid={`skeleton-${element.id}`} />
}
